import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AuthUser } from '../../models/auth-user.model';


@Component({
  selector: 'app-page-home',
  templateUrl: './page-home.component.html'
})
export class PageHomeComponent implements OnInit {

  user: AuthUser;

  constructor(private userService: UserService) {
    this.userService.currentUser.subscribe(authUser => {
      this.user = authUser;
    });
  }

  get isMedicalUser() {
    return this.user && !this.user.isAdmin() && this.user.hasRole('medico');
  }

  /*
  private getUserDetail(username: string) {
    this.userService.getUserByUsername(username).subscribe(res => {
      this.user.userInfo = res.userInfo;
    });
  }
  */

  ngOnInit() {  }
}
